export const multiView = `
<svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11V17C18 17.5523 17.5523 18 17 18H7C6.44771 18 6 17.5523 6 17V11Z" fill="white"/>
<rect x="6" y="19" width="8" height="5" rx="1" fill="white"/>
<rect x="15" y="19" width="7" height="5" rx="1" fill="white"/>
<rect x="23" y="19" width="8" height="5" rx="1" fill="white"/>
<rect x="19" y="10" width="12" height="8" rx="1" fill="white"/>
</svg>
`;
